export enum SignatureFlowStep {
  View = "view",
  Placing = "placing",
}
